import React from 'react';
import { Loader2, AlertCircle } from 'lucide-react';

// Explicit loading / error / empty states shared across screens.
// Keeps visual system consistent (warm palette) without redesigning screens.
const StateFallback = ({ variant = 'loading', message, onRetry }) => {
  const isLoading = variant === 'loading';

  return (
    <div className="px-6 pt-24 flex flex-col items-center text-center">
      {isLoading ? (
        <Loader2
          size={26}
          className="animate-spin mb-4"
          style={{ color: 'var(--lp-body)' }}
        />
      ) : (
        <AlertCircle
          size={26}
          className="mb-4"
          style={{ color: 'var(--lp-body)' }}
        />
      )}
      <p className="text-[15px] mb-5" style={{ color: 'var(--lp-body)' }}>
        {message || (isLoading ? 'Loading…' : 'Something went wrong.')}
      </p>
      {!isLoading && onRetry && (
        <button
          onClick={onRetry}
          className="lp-btn-sage px-6 py-3 text-[15px]"
        >
          Try again
        </button>
      )}
    </div>
  );
};

export default StateFallback;
